module.exports = __webpack_public_path__ + "static/img/naicha.fcb60018.png";